import { api } from "../lib/axios";

import type { ApiData } from "./apiData";
import type { Namespace } from "../types/namespace";

type ListNamespacesResponse = ApiData<Array<Namespace>>

async function listNamespaces() {
    const response = await api.get<ListNamespacesResponse>('/vector/all')

    return response.data
}

export { listNamespaces, type ListNamespacesResponse }